export const navLinks = [
  // {
  //   id: 100,
  //   txt: "AI Search",
  //   path: "/ai-search",
  //   newTab: false
  // },
  {
    id: 200,
    txt: "Browser",
    path: "/private-browser",
    newTab: false
    
  },
  {
    id: 300,
    txt: "Wallet",
    path: "/wallet",
    newTab: false
  },

  // {
  //   id: 400,
  //   txt: "Token",
  //   path: "/hero-token",
  //   newTab: false
  // },
  {
    id: 500,
    txt: "Market",
    path: "/market",
    newTab: false
  },
  // {
  //   id: 600,
  //   txt: "Merchant Services",
  //   path: "https://pay.hero.io",
  //   newTab: true
  // },

  {
    id: 700,
    txt: "Web3 Store",
    path: "https://web3store.hero.io",
    newTab: true
  },

  // {
  //   id: 800,
  //   txt: "DApps",
  //   path: "https://dapps.hero.io",
  //   newTab: true
  // },
  {
    id: 900,
    txt: "White paper",
    path: "https://hero-5.gitbook.io/hero-paper",
    newTab: true
  }
];

export const FooterLinks = [
  {
    id: 1000,
    txt: "About",
    path: "/about"
  },
  {
    id: 1100,
    txt: "Terms & Conditions",
    path: "/terms-conditions"
  },
  {
    id: 1200,
    txt: "Privacy policy",
    path: "/privacy-policy"
  },
  {
    id: 1300,
    txt: "Cookie Policy",
    path: "/cookie-policy"
  },
  {
    id: 1400,
    txt: "Support",
    path: "/support"
  },
  {
    id: 1500,
   txt: "Events",
    path: "/events"
  },
  {
    id: 1600,
   txt: "Blog",
    path: "/blog"
  },
  {
    id: 1700,
   txt: "FAQ",
    path: "/faq"
  },
];

export const GeneralTermsAndConditions = [
  `PLEASE READ THESE GENERAL TERMS AND CONDITIONS CAREFULLY. THESE GENERAL TERMS AND CONDITIONS IS A LEGAL CONTRACT GOVERNING ACCESS TO OUR PLATFORM AND USING OUR SERVICES IN GENERAL. THESE GENERAL TERMS AND CONDITIONS ARE ENTERED INTO BETWEEN YOU AND PAYEXCHANGE. BY ACCESSING OUR PLATFORM AND CLICKING ON “I AGREE WITH GENERAL T&C”, YOU CONFIRM THAT YOU HAVE READ, UNDERSTOOD, ACCEPTED AND AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS STIPULATED IN THESE GENERAL TERMS AND CONDITIONS. IF YOU DO NOT AGREE TO ANY TERMS AND CONDITIONS STIPULATED IN THESE GENERAL TERMS AND CONDITIONS OR OUR PRIVACY POLICY, OR ANY ADDITIONAL APPLICABLE TERMS AND CONDITIONS, DO NOT ACCESS`,
  `OUR PLATFORM AND DO NOT CLICK ON “I AGREE WITH GENERAL T&C”.`,
  `THE USE OF OUR SPECIFIC SERVICES ARE DESCRIBED BY TERMS AND CONDITIONS GOVERNING EACH OF SERVICE SEPARATELY. BEFORE STARTING TO USE ANY OF OUR SERVICES YOU WILL BE ASKED TO READ AND AGREE WITH THAT SPECIFIC SERVICE TERMS AND CONDITIONS`,
  `WE URGE YOU TO DOWNLOAD A COPY OF THESE GENERAL TERMS AND CONDITIONS FOR FUTURE REFERANCE AS THEY MAY CHANGE FROM TIME TO TIME AND SAVE IT TO YOUR COMPUTER TO HAVE IT AVAILABLE FOR REVIEW ANYTIME. IN CASE YOU CHOOSE NOT TO DO SO, THESE GENERAL TERMS AND CONDITIONS ARE ALWAYS AVAILABLE ON OUR WEBSITE.`,
  `THE RISK WARNING, THE PRIVACY POLICY, THE AML POLICY, THE DIGITAL CURRENCY EXCHANGE SERVICE TERMS AND CONDITIONS FORM AN INTEGRAL PART OF THESE GENERAL TERMS AND CONDITIONS, WHICH ESTABLISH GENERAL TERMS AND CONDITIONS APPLICABLE TO ACCESS TO OUR PLATFORM AND USE OF OUR SERVICES IN GENERAL. CONSENT TO THESE GENERAL TERMS AND CONDITIONS, WHICH RESULTS IN A LEGAL CONTRACT, SHALL BE DEEMED TO BE THE ENTRY INTO FORCE OF ALL THE ADDITIONAL DOCUMENTS FORMING THESE GENERAL TERMS I. E. THE RISK WARNING, THE PRIVACY POLICY, THE AML POLICY, THE DIGITAL CURRENCY EXCHANGE SERVICE TERMS AND CONDITIONS`,
  `VALUE OF DIGITAL CURRENCIES MAY FLUCTUATE SIGNIFICANTLY AND THERE IS A SUBSTANTIAL RISK OF ECONOMIC LOSSES WHEN DEALING WITH DIGITAL CURRENCIES. BY MAKING USE OF OUR SERVICES, YOU ACKNOWLEDGE AND AGREE THAT YOU ACKNOWLEDGED YOURSELF WITH THE RISK WARNING DOCUMENT PUBLISHED ON OUR WEBSITE AND: (1) YOU ARE AWARE OF THE RISKS ASSOCIATED WITH TRANSACTIONS OF DIGITAL CURRENCIES; (2) YOU SHALL ASSUME ALL RISKS RELATED TO THE USE OF OUR SERVICES AND TRANSACTIONS OF DIGITAL CURRENCIES; AND (3) PAYEXCHANGE SHALL NOT BE LIABLE FOR ANY SUCH RISKS ATTACHED THERETO OR ADVERSE OUTCOMES.`
]

export const GeneralPROVISIONS = `The following words when capitalized in these Terms have the following meanings:`;

export const GeneralAccount = ` an account created by Payexchange to the User providing the features required to use the Services;`;
export const GeneralAML = `means anti-money laundering and counter-terrorism financing;`;
export const GeneralBuyer = `as it is described in Payexchange Digital Currency Exchange Services Terms and Conditions;`;


export const General = [
  {
    title: "Account",
    des: "an account created by Payexchange to the User providing the features required to use the Services;"
  },

  {
    title: "AML/CTF",
    des: "means anti-money laundering and counter-terrorism financing;"
  },
  {
    title: "Buyer",
    des: "as it is described in Payexchange Digital Currency Exchange Services Terms and Conditions;"
  },
  {
    title: "Payexchange or we or us",
    des: "Payexchange, UAB a private limited liability company, established and operating under the laws of Lithuania, legal entity code 306098972, registered address at Eišiškių Sodų 18-oji g. 11, LT-02194 Vilnius, Lithuania;"
  },
  {
    title: "Digital Currency",
    des: "(also known as cryptocurrency, virtual currency, virtual asset) means a digital representation of value that can be digitally traded, or transferred, and can be used for payment or investment purposes, and supported by Payexchange in accordance with Sections 6 of these Terms. Digital Currency does not include digital representations of fiat currencies, securities and other corresponding financial assets;"
  },
  {
    title: "Digital Currency Exchange Services Terms and Conditions ",
    des: " Payexchange Digital Currency Exchange Services Terms and Conditions governing your use of our Digital Currency exchange services;"
  },
  {
    title: "Fiat Currency",
    des: "a currency which in accordance with valid laws is legal tender;"
  },
  {
    title: "Privacy Policy",
    des: "the policy governing the processing of personal data by Payexchange"
  },
  {
    title: "Prohibited Use",
    des: " any prohibited use of the Services in accordance with Sections 8 of these Terms;"
  },
  {
    title: "Order",
    des: "an order to the Digital Currency through our Platform;"
  },
  {
    title: "Platform",
    des: "an IT solution created by Payexchange for trading Digital Currencies and available here;"
  },
  {
    title: "Seller",
    des: "as it is described in Payexchange Digital Currency Exchange Services Terms and Conditions;"
  },
  {
    title: "Services",
    des: "services related to Digital Currencies and provided by Payexchange in accordance with these Terms and separate specific Services Terms;"
  },
  {
    title: "Services Terms",
    des: "terms and conditions for our separate specific Services;"
  },
  {
    title: "Suspension Event",
    des: "any event in accordance with Sections 7 of these Terms;"
  },
  {
    title: "Terms",
    des: "these terms and conditions as amended from time to time and published on our website;"
  },
  {
    title: "Transaction",
    des: " operation of trading Digital Currency on Payexchange Platform in accordance with these Terms;"
  },
  {
    title: "User or you",
    des: "an individual or a legal entity registered on the Platform, holding the Account and using the Services."
  },
  {
    title: "User or you",
    des: "an individual or a legal entity registered on the Platform, holding the Account and using the Services."
  },
]

export const Interpretation = [
  {
    title: "1.2.1.",
    des: "References to Sections and Articles, unless stated or the context requires otherwise, shall be construed as references to Sections and Articles of these Terms."
  },
  {
    title: "1.2.2.",
    des: "References to legal acts (if any) shall include references to any amendment, modification, extension, consolidation, replacement or re-enactment of any such legal act."
  },
  {
    title: "1.2.3.",
    des: "In these Terms:"
  },

  {
    title: "a.",
    des: "words in the singular include the plural and vice versa;"
  },
  {
    title: "b.",
    des: "references to persons includes legal persons, unincorporated associations and partnerships, regardless if not having a separate legal personality;"
  },
  {
    title: "c.",
    des: "words importing the masculine gender include the feminine and the neuter and vice versa;"
  },
  {
    title: "d.",
    des: " words “include”, “includes” and “including” shall be deemed to be followed by the phrase “without limitation”."
  },

]


export const Contractual = [
  {
    title: "1.3.1.",
    des: " These Terms constitute a legal agreement and create a binding contract between you and Payexchange."
  },
  {
    title: "1.4.",
    des: "Supplementary Terms"
  },
  {
    title: "1.4.1.",
    des: "Due to the rapid development of Digital Currencies, these Terms do not enumerate or cover all rights and obligations of each party, and do not guarantee full alignment with needs arising from future development. Therefore, all other agreements entered into separately between you and Payexchange are deemed supplementary terms that are an integral part of these Terms and shall have the same legal effect. Your access to our Platform is deemed your acceptance of these supplementary terms."
  },

]

export const ScopeOfTheseTerms = [

  {
    title: "2.1.",
    des: "These Terms govern the use of our Platform, including, but not limited to, opening and using your Account and our Services in general. Together with Payexchange Privacy Policy, Risk Warning, AML Policy and Digital Currency Exchange Service Terms and Conditions these Terms constitute a legally binding relationship between you and us."
  },
  {
    title: "2.2.",
    des: "Persons that are not registered on the Platform shall only have the opportunity to view and use part of the information on the Platform and shall not have the ability to use the Services. By accessing our Platform (irrespective if you choose to use our Services or not) and clicking on “I agree with General T&C”, you expressly agree to comply with the provisions of these Terms, Privacy Policy, Risk Warning, AML Policy and Digital Currency Exchange Service Terms and Conditions governing access to the Platform."
  },
]

export const ELIGIBILITY = [
  {
    title: "3.1.",
    des: "Eligibility"
  },
  {
    title: "3.1.1.",
    des: "You are only permitted to access our Platform and use our Services if you are a registered"
  },
  {
    title: "",
    des: "User and comply with all of the following criteria:"
  },
  {
    title: "3.1.1.1.",
    des: "if you are an individual, you must be aged 18 years or older, taking into consideration the laws applicable to you regarding the age for a full legal capacity;"
  },
  {
    title: "3.1.1.2.",
    des: "if you are a legal person, you must be duly established and operate in a country in which our Services are legally accessible;"
  },
  {
    title: "3.1.1.3.",
    des: "You are eligible to use Payexchange Services and hold an Account with Payexchange taking into consideration the laws applicable to you. You are solely responsible to assess if you are eligible to use Payexchange Services. In addition to the foregoing, you undertake to immediately cease using Payexchange Services should it become illegal under the laws applicable to you;"
  },
  {
    title: "3.1.1.4.",
    des: "You must provide all of the information and/or data and/or documents required by us to set up and maintain your Account and verify your identity following our instructions; "
  },
  {
    title: "3.1.1.5.",
    des: "Payexchange must be satisfied with the outcome of the identity, fraud, background checks and other money laundering and terrorist financing checks it (or any third party) conducts in relation to you at any time during the term of your and our relationship;"
  },
  {
    title: "3.1.1.6.",
    des: "at all times you comply with the Terms as well as all applicable laws."
  },
  {
    title: "3.1.2.",
    des: "Payexchange remains solely entitled to restrict or limit your access and/or use of our Platform and/or Services without indicating any reasons."
  },
  {
    title: "3.2.",
    des: "Your general agreements and promises"
  },
  {
    title: "3.2.1.",
    des: "By accessing the Platform and using the Services, you: "
  },
  {
    title: "3.2.1.1. ",
    des: "confirm that you are eligible to access our Platform and use our Services by complying with criteria listed in Article 3.1.1; "
  },
  {
    title: "3.2.1.2. ",
    des: "agree and acknowledge that any and all actions performed by using your Account shall be valid and causing the same legal effects as the actions formalized by a paper document signed by you, and if you are acting on behalf of a legal entity, then also by a paper document signed by you and endorsed with the stamp of such entity; "
  },
  {
    title: "3.2.1.3. ",
    des: "in case of legal representation, you are duly authorized to enter into a contractual relationship with us based on these Terms on behalf of the person you are representing. You will be requested to provide duly signed and certified documents evidencing your right as a representative to access and use our Platform and/or Services on behalf of the represented person. Failure to submit such documents will result in denial to access to our Platform and/or use our Services; "
  },
  {
    title: "3.2.1.4. ",
    des: "authorise Payexchange to make the inquiries it considers necessary, from time to time, to verify your identity, undertake fraud checks and carry out other measures that of the view of Payexchange are fit and necessary to meet the requirements set forth in the applicable laws regarding the prevention of money laundering and terrorist financing and comply with other legal obligations of Payexchange. You expressly consent to furnish any and all such information, documents and data; "
  },
  {
    title: "3.2.1.5. ",
    des: "confirm that you have read, understood and agreed to be bound by these Terms, our Privacy Policy, Risk Warning, AML policy, Digital Currency Exchange Service Terms and Conditions and any other document (if any) to the Terms; "
  },
  {
    title: "3.2.1.6. ",
    des: "consent that, whenever a Transaction is made, the Platform shall send and receive funds to/from the Buyer’s and the Seller’s Accounts opened in their name and on their behalf in relation to the Transaction;"
  },
  {
    title: "3.2.1.7. ",
    des: "commit to be bound by these Terms, our Privacy Policy and any other document (if any) to the Terms and comply to them;"
  },
  {
    title: "3.2.1.8.",
    des: "undertake to pay all fees associated with Transactions and Services in accordance with Sections 10 of these Terms; "
  },
  {
    title: "3.2.1.9.",
    des: "confirm that you have sufficient knowledge of Digital Currencies to enter into Transactions, and understand that you are solely responsible for determining the nature, potential value, suitability, risks and appropriateness of our Services; "
  },
  {
    title: "3.2.1.10.",
    des: "approve that the funds deposited in your Account in any form belong to you and are derived from legitimate sources. Payexchange shall be entitled to ask for any proof of evidence confirming legitimacy of funds; "
  },
  {
    title: "3.2.1.11.",
    des: "confirm that you accept the risk so fusing the Services and accessing the Platform,and have read and understand the Risk Warning available here;  "
  },
  {
    title: "3.2.1.12.",
    des: "confirm that Payexchange has not advised you to, nor recommended to you to use the Services and/or enter into Transactions related to Digital Currencies; "
  },
  {
    title: "3.2.1.13.",
    des: "commit to ensure that any personal information you provide to Payexchange is accurate, up to date and complete and relates solely to you, and to update us within 10 (ten) calendar days of any changes to any information you have provided to us in connection with these Terms and/or of any circumstances that are material for the performance of these General Terms e. g. your name, representative‘s name, place of residence/registered office address, email address, etc. At our request, you must submit any documents (originals, duly certified paper copies or scanned copies) supporting such changes of information or circumstances; "
  },
  {
    title: "3.2.1.14.",
    des: "approve that your personal data and identifiers may be shared with appropriately authorised third parties, including, but not limited to, banks required for us to provide our Services to you and in accordance with the applicable laws regarding AML/CTF; "
  },
  {
    title: "3.2.1.15.",
    des: "undertake to provide us without undue delay with any additional information, documents and data we may request from you; and "
  },
  {
    title: "3.2.1.16.",
    des: "represent and warrant that your access to our Platform and use of our Services do not violate any applicable laws or regulations of any jurisdiction that applies to you."
  },
  {
    title: "3.2.2.",
    des: "By accepting these Terms, you represent and warrant that all of the above is true and accurate on the day of acceptance of these Terms and shall remain each day until you cease to use our Services."
  },
]

export const YOURACCOUNT = [
  {
    title: "4.1.",
    des: "Registration and activation"
  },
  {
    title: "4.1.1.",
    des: "To use our Services, you must first create the Account and have it activated. You are only entitled to create the Account if you meet all the eligibility criteria set forth in Sections 3 of these Terms."
  },
  {
    title: "4.1.2.",
    des: "To create an Account you must provide us with your full name, valid email address, set up a password and confirm your acceptance of these Terms and related documents. You will not be able to access our Services and benefit from them until you have your Account activated."
  },
  {
    title: "4.1.3.",
    des: "To have your Account activated, you will have to submit any and all information and/or data and/or documents required by us. In case of legal representation the representative shall also provide us with documents proving his/her authorizations. In case of a legal person, the representative shall also provide us with information about the director of a legal entity. We may ask you to verify your email address and/or phone number. We will review and assess information and data and documents submitted to us by you. Should the outcome of such assessment be positive, your Account will be activated and, provided that you accept the separate specific Services Terms, you will be able to start using our Services."
  },
  {
    title: "4.1.4.",
    des: "The methods of depositing/withdrawing Digital Currencies to/from your Account shall be indicated on your Account. We shall have a right to unilaterally add and respectively discontinue any deposit/withdrawal method at any time and without indicating any reason."
  },
  {
    title: "4.1.5.",
    des: "We do not give a guarantee regarding any deposit/withdrawal method available on your Account at a particular time, as long as at least one deposit/withdrawal method is available to you."
  },
  {
    title: "4.2.",
    des: "In relation to your Account you undertake to:"
  },
  {
    title: "4.2.1.",
    des: "create a strong password for your Account (i. e. a password that is different from any other password you use for any other website or online service and that cannot be easily guessed). You must change your password regularly and immediately in case you suspect your password has been compromised;"
  },
  {
    title: "4.2.2.",
    des: "keep your Account login information,password and any forms of multi-factor authentication confidential and separately from each other, as well as separately from any other information or documents relating to your Account;"
  },
  {
    title: "4.2.3.",
    des: "not store your login information on any device, irrespectively if such device is of your private or public use;"
  },
  {
    title: "4.2.4.",
    des: "not let any person access your Account at any time without our prior written permission;"
  },
  {
    title: "4.2.5.",
    des: "not leave your computer, phone or any other device unattended while you are logged in to your Account;"
  },
  {
    title: "4.2.6.",
    des: "always log out from your Account, especially when accessing your Account from public devices;"
  },
  {
    title: "4.2.7.",
    des: "not open more than one Account, except with our prior written permission. We discourage you from attempting to circumvent this provision, e. g. by requesting to open a second Account unless you have a solid ground for such a request and we find it fit or by trying to open the Account using a different email address etc. Such attempt will be considered as an attempt of fraud and will result in termination of the relationship between us and you;"
  },
  {
    title: "4.2.8.",
    des: "notify us immediately in case you identify or suspect any unauthorised access to your Account."
  },
  {
    title: "4.3.",
    des: "In relation to your Account you confirm that:"
  },
  {
    title: "4.3.1.",
    des: "Payexchange has the right to make inquiries to you directly or through third parties which we employ to verify your identity and/or for the purpose of protection against fraud, terrorism financing and/or money laundering;"
  },
  {
    title: "4.3.2.",
    des: "You understand that you are responsible for maintaining the security of your Account login information and password. In the event you hand over your login information to a third party, you bear full responsibility and liability for such actions and all consequences will be born on you. In addition to the foregoing, such voluntary handing over of the login information to a third party will be considered a material breach of the Terms and, by our unilateral decision, may result in termination of relationship between us and you;"
  },
  {
    title: "4.3.3.",
    des: "You understand and consent that you:"
  },
  {
    title: "4.3.3.1.",
    des: "Will not be provided with a private key in relation to the Digital Currency kept with us on your Account;"
  },
  {
    title: "4.3.3.2.",
    des: "Do not own and will not claim to own a newly created asset appeared after circumstances known as “forks” and/or “hard forks”, unless it is indicated otherwise by Payexchange;"
  },
  {
    title: "4.3.4.",
    des: "You understand that anyone accessing your Account will be able to enter into Transactions and Payexchange shall have no obligation to verify or take any steps to verify any instruction received from you or appearing to be sent by you;"
  },
  {
    title: "4.3.5.",
    des: "Payexchange shall process your Transactions in accordance with instructions provided by you; thus, you shall carefully verify all instructions prior to placing any Orders. In case there is an error in the instructions provided by you, however, such error does not result in impossibility to execute the Order, Payexchange will not accept any responsibility or liability for the consequences of execution of such Order;"
  },
  {
    title: "4.3.6.",
    des: "You understand that by using our Services you take full responsibility and liability for and accept all risks of unauthorised use of your Account caused by your negligence or breach of these Terms."
  }
];
export const AMLAndCTF = [
  {
    title: "5.1.",
    des: "In order to comply with applicable AML/CTF requirements, it is necessary for Payexchange to obtain from User and retain the necessary documents, information and data."
  },
  {
    title: "5.2.",
    des: "For the purposes of AML/CTF, User must provide Payexchange with the requested information, data and documents. Payexchange shall have the right to take other legitimate measures to implement applicable AML/CTF requirements. Failure to submit requested information and/or data and/or documents or provision of incorrect or incomplete information and/or data and/or documents, or failure to comply with Payexchange other instructions may, by Payexchange unilateral decision, result in Platform and/or Services being unavailable to you."
  },
  {
    title: "5.3.",
    des: "At any time during our relationship, Payexchange shall have the right to demand from User any documents, data and information, including those confirming the legal grounds as well as sources (origin) of User‘s funds and other assets and/or other documents and information to the extent."
  },
  {
    title: "5.4.",
    des: "Payexchange shall have the right to restrict or terminate the access to the Platform and/or provision of Services if User does not submit to Payexchange or avoid, or refuse to submit to Payexchange the requested documents, data and/or information, or conceal the requested documents, data and/or information, or provide incorrect or incomplete requested information, or otherwise fail to comply with any other instructions Payexchange gives."
  },
  {
    title: "5.5.",
    des: "Payexchange uses reliable and independent sources of information and other lawful methods to verify the information provided by User."
  },
  {
    title: "5.6.",
    des: "Payexchange carries out monitoring of your activities within the Platform. In case of suspicious activities we shall have the right to suspend them for a certain period of time as well as we shall have the right to fulfill our obligations to report suspicious activities to competent authorities."
  },
  {
    title: "5.7.",
    des: "Once we establish that you pose an unacceptable risk of AML/CTF to us, we shall have the right to immediately and unilaterally terminate the relationship with you."
  }

]
export const SUPPORTEDDIGITALCURRENCIES = [
  {
    title: "6.1.",
    des: "Digital Currencies supported by Payexchange are reflected on the Platform and are accessible here. In case it is required in accordance with the applicable laws, order of a court or government agency, change of the operating rules in the underlying Digital Currency’s network, or any technological issue outside of our reasonable control, Payexchange, in its absolute sole discretion, shall have a right to add or remove from the Platform any Digital Currency at any time and without any notice."
  },
  {
    title: "6.2.",
    des: "Payexchange assumes no responsibility or liability for your attempt to use your Account for any Digital Currencies that Payexchange does not support at a particular time."
  },
  {
    title: "6.3.",
    des: "Payexchange does not control or own any of the underlying networks or software protocols that govern the operation of the Digital Currencies supported by Payexchange."
  },
  {
    title: "6.4.",
    des: "Payexchange shall not stand behind or underwrite any Transaction you enter into using the Platform."
  },
  {
    title: "6.5.",
    des: "Digital Currency withdrawal may be delayed for an indefinite period due to Payexchange retrieving it from offline storage."
  },
  {
    title: "6.6.",
    des: "The amount of time required to process a Transaction will depend on various factors, including the performance of third parties. We make no guarantee as to when a particular Transaction will be executed."
  },
  {
    title: "6.7.",
    des: "Payexchange shall have a right at any time to establish Transaction limits without prior notice and without specifying any reasons."
  },
  {
    title: "6.8.",
    des: "Payexchange shall have the right to refuse to process and/or cancel any Order or Transaction at any time in accordance with the requirements set forth by the applicable law, in response to a court or government order, to enforce Transaction limits or in case a Suspension Event occurs, or in case of other significant (in Payexchange opinion) circumstances."
  },
  {
    title: "6.9.",
    des: "Digital Currencies are a risky asset class and trading in Digital Currencies increases those risks. You confirm that you have read and understood the Risk Warning and agree to solely accept those risks."
  },
  {
    title: "6.10.",
    des: "The amount or value of the Digital Currencies held by you is guaranteed or underwritten neither by Payexchange, nor by any third party, and you may lose the Digital Currencies or the value thereof stored on your Account in a short period of time. In such case, you shall have no right to claim damages to Payexchange or any other third party (including loss of profit), as well as any liability or incurred inconveniences, unless the loss resulted from Payexchange’ breach of these Terms."
  },
  {
    title: "6.11.",
    des: "Payexchange supports an asset-specific amount of decimals which is never more than 8 (eight) decimals. An asset-specific excess amount is always deducted and you agree that you no longer own that excess after it has been deducted. Be advised not to deposit amounts of more decimals than specified here."
  }

]
export const SUSPENSION = [
  {
    title: "7.1.",
    des: "Payexchange shall have the right to suspend your access to the Platform and/or the Services in any of the following cases without a prior notice for any period of time in its discretion if Payexchange considers it necessary or desirable to do so:"
  },
  {
    title: "7.1.1.",
    des: "As a result of any Prohibited Use;"
  },
  {
    title: "7.1.2.",
    des: "Following a “hard fork” or other sudden change in operating rules in any underlying Digital Currency network;"
  },
  {
    title: "7.1.3.",
    des: "Following a force majeure event or a market disruption event;"
  },
  {
    title: "7.1.4.",
    des: "To comply with the applicable law or change thereof, or regulatory guidance;"
  },
  {
    title: "7.1.5.",
    des: "In Payexchange opinion, there are other significant circumstances."
  },
  {
    title: "7.2.",
    des: "Consequences of Suspension Event"
  },
  {
    title: "7.2.1.",
    des: "In case the Suspension Event occurs, Payexchange shall have the right to suspend access to the Platform and/or one or more Services to one or more (or all) Users for as long as Payexchange determines, in good faith, is necessary or prudent in view of the interests of Payexchange and its Users."
  },
  {
    title: "7.2.2.",
    des: "Payexchange shall not be liable to any User or third party for any loss (including loss of profit), liability or inconvenience arising as a result of any Suspension Event, or suspension of any Services or access to the Platform arising from the action taken following a Suspension Event."
  },
  {
    title: "7.2.3.",
    des: "Upon its discretion Payexchange shall have the right to provide you with the opportunity to withdraw your Digital Currencies from your Account and transfer them to a third party service."
  }


]
export const PROHIBITEDUSE = [
  {
    title: "8.1.",
    des: "It is strictly prohibited to use the Platform or any Service in any of the following cases:"
  },
  {
    title: "8.1.1.",
    des: "To conduct or engage in any illegal or unlawful activity;"
  },
  {
    title: "8.1.2.",
    des: "To hide or disguise the proceeds of any illegal or unlawful activity;"
  },
  {
    title: "8.1.3.",
    des: "To infringe our proprietary intellectual property, or the proprietary intellectual property of any other person;"
  },
  {
    title: "8.1.4.",
    des: "To engage in gambling;"
  },
  {
    title: "8.1.5.",
    des: "In relation to any Digital Currency that Payexchange does not support at the relevant time;"
  },
  {
    title: "8.1.6.",
    des: "To engage in any deceptive, fraudulent or malicious activity, including by launching malware or viruses, or seeking to hack into any Accounts or steal any Digital Currencies held by any other User;"
  },
  {
    title: "8.1.7.",
    des: "To reverse-engineer, decompile, disable, or disassemble any software running on the Platform;"
  },
  {
    title: "8.1.8.",
    des: "To allow anyone who is not a duly authorized person to have access to your Account;"
  },
  {
    title: "8.1.9.",
    des: "To promote securities;"
  },
  {
    title: "8.1.10.",
    des: "To harm in any way Payexchange, any person associated with Payexchange, or any third party;"
  },
  {
    title: "8.1.11.",
    des: "In case you are not a User;"
  },
  {
    title: "8.1.12.",
    des: "To offer or purport to offer any Service to any person who is not a User; or"
  },
  {
    title: "8.1.13.",
    des: "To engage in any other use or activity that breaches these Terms or, in Payexchange opinion, is unacceptable for Payexchange."
  },
  {
    title: "8.2.",
    des: "Payexchange shall have the right without any prior notice or explanation to block or refuse any person (including any User) from accessing the Platform and/or any Service and/or any Transaction in case it believes in good faith that such person, Service or Transaction is related to a Prohibited Use."
  }
]
export const ADDITIONAL = [
  {
    title: "9.1.",
    des: "In the event we believe you have breached or are in breach of these Terms or any applicable law, we shall have the right to:"
  },
  {
    title: "9.1.1.",
    des: "Limit, suspend or cancel your access to the Platform and/or Services;"
  },
  {
    title: "9.1.2.",
    des: "Warn any Users of your actions;"
  },
  {
    title: "9.1.3.",
    des: "Issue a warning to you;"
  },
  {
    title: "9.1.4.",
    des: "Inform competent institutions and cooperate fully with any law enforcement authorities by, including, but not limited to, disclosing your information to such authorities."
  },
  {
    title: "9.2.",
    des: "This Sections does not limit any other rights granted to us by the applicable law."
  }
]
export const FEES = [
  {
    title: "10.1.",
    des: "We shall charge you and you agree and undertake to pay to us the fees for our Services as specified here."
  },
  {
    title: "10.2.",
    des: "Payexchange may, in its absolute sole discretion, update the fees for Services at any time. Any updated fees for Services will apply to any of your use of Services that occurs following the effective date of the updated fees. If no effective date of the updated fees is specified, then updated fees come into force immediately upon their publication."
  },
  {
    title: "10.3.",
    des: "You authorize Payexchange to deduct from your Digital Currencies held by Payexchange any applicable fees that you owe to Payexchange."
  },
  {
    title: "10.4.",
    des: "Please ensure that the required fees due from you are available to us on the due date. If you do not have enough Digital Currencies to pay the fees or any other amounts due, we reserve the right to suspend the provision of our Services to you until such fees/amounts due will be paid to us."
  }
]
export const TAXES = [
  {
    title: "11.1.",
    des: "You are solely responsible for duly and timely declaration/reporting of your activities on your Account and gains in relation thereto in compliance with the law applicable to you. Payexchange shall have no obligation to provide any information to any third parties (except when fulfilling its own obligation in relation to these Terms or under applicable law) regarding your activities on your Account and gains in relation to your activities on the Account."
  },
  {
    title: "11.2.",
    des: "You are solely responsible for paying any and all taxes applicable to you in relation to using our Services in a timely and duly manner."
  },
  {
    title: "11.3.",
    des: "It is your responsibility to determine what, if any, taxes you are obligated to pay in relation to the Transactions and Digital Currencies you hold or otherwise."
  },
  {
    title: "11.4.",
    des: "Payexchange makes no representations in relation to tax liabilities, assumes no tax liability to any User, assumes no responsibility for the tax liability of yours or any other User, not for collecting, reporting, withholding or remitting any taxes arising from any Transactions that you may enter into."
  },
  {
    title: "11.5.",
    des: "Where we have an obligation under applicable law or voluntarily decide to report to any competent authorities any information that is related with your tax obligations, you undertake to provide us with the requested documents, data and information."
  }

]
export const LIABILITY = [
  {
    title: "12.1.",
    des: "To the extent permitted by law, Payexchange and its associated parties exclude all liability and responsibility for any loss, damages, costs or expenses, whether in tort (including negligence), contract or otherwise and whether direct, indirect, or consequential (including in connection with business interruption), which you or any other person may suffer or incur in connection with the Services, the use or inability to use the Platform, and in respect of any Digital Currency or otherwise."
  },
  {
    title: "12.2.",
    des: "Where and to the extent liability for breach or any implied warranty or condition, or otherwise, cannot be excluded, Payexchange liability to you is limited to the total amount of the fees we have earned from you as a result of supplying the Services to you."
  },
  {
    title: "12.3.",
    des: "Payexchange shall not be held liable in any way to you or any third party for any financial decision or action taken by you when using the Services."
  },
  {
    title: "12.4.",
    des: "Payexchange does not provide any financial, investment or legal advice in connection with the Services. Payexchange may provide information on the price, range, volatility of Digital Currencies and Event that have affected the price of Digital Currencies, but it should not be considered as an investment or financial advice and should not be construed as such. Any decision to Digital Currencies is the User’s decision and Payexchange will not be liable for any loss suffered in relation thereto."
  },
  {
    title: "12.5.",
    des: "Payexchange takes no responsibility for and will not be liable for any financial loss arising from the use of your Account, including, but not limited to, loss due to technical faults resulting in a loss of ability to access your Account; system hacks; server failure or data loss; technical faults of the Digital Currency system; forgotten passwords; security of your password; unauthorized access to your Account; corrupted files or data; incorrectly constructed transactions or mistyped Digital Currency addresses."
  },
  {
    title: "12.6.",
    des: "Without limiting other terms in these Terms, you acknowledge that Payexchange bears no liability for any damage, loss (including loss of profit), delay, inconvenience, failure in performance or interruption of Service or Transaction, in each case caused by or resulting from (directly or indirectly):"
  },
  {
    title: "12.6.1.",
    des: "Any computer virus, spyware, scareware, Trojan horse, worms or other malware or cyber, phishing or spoofing attack that may affect your computer or other device;"
  },
  {
    title: "12.6.2.",
    des: "Any cause or condition beyond our reasonable control;"
  },
  {
    title: "12.6.3.",
    des: "Any “hardfork”, “softfork”, or other change in the operating rules of an underlying Digital Currency network;"
  },
  {
    title: "12.6.4.",
    des: "Our good faith election not to support an unsupported branch of a forked protocol, or to configure or reconfigure our systems as a result of the forked protocol or other change to the operating rules;"
  },
  {
    title: "12.6.5.",
    des: "Any suspension of the Services following the Suspension Event or as otherwise permitted under these Terms;"
  },
  {
    title: "12.6.6.",
    des: "Inaccurate Orders placed;"
  },
  {
    title: "12.6.7.",
    des: "You are not meeting your legal obligations, including, but not limited to, your tax obligations."
  },
  {
    title: "12.7.",
    des: "Payexchange manages the Payexchange Platform with due care, however it is likely that interruptions, failures and other issues occur. Payexchange gives no guarantee with respect to finding solutions for any such problems as soon as possible. Payexchange assumes no liability whatsoever for any damage caused by interruptions of Payexchange Platform."
  },
  {
    title: "12.8.",
    des: "Indemnity"
  },
  {
    title: "12.8.1.",
    des: "Each User indemnifies Payexchange and holds Payexchange harmless for any loss, cost, liability or expense sustained or incurred by it as a result of the relevant User or User breaching these Terms, including by:"
  },
  {
    title: "12.8.1.1.",
    des: "Providing false information, data and/or documents in relation to your eligibility to use Payexchange Services (Article 3.1.1) or making false promises (Article 3.2.1);"
  },
  {
    title: "12.8.1.2.",
    des: "Engaging in any Prohibited Use;"
  },
  {
    title: "12.8.1.3.",
    des: "Any other breach by you of the Terms, Privacy Policy, Exchange Service Terms and Conditions and any other document (if any) to the Terms;"
  },
  {
    title: "12.8.1.4.",
    des: "Any reliance by you on any information obtained through the Platform."
  }

]
export const TERMINATION = [

  {
    title: "13.1.",
    des: "These Terms are applicable to you from the moment you access the Platform. Your access to the Platform constitutes your consent to be bound by these Terms."
  },
  {
    title: "13.2.",
    des: "At any time and for any reason at its sole discretion, Payexchange may unilaterally terminate the relationship with you, your access to your Account and may halt any pending Transactions or execution of any payments without giving advance notice to you. Payexchange shall incur no liability or obligation for the termination of relationship with you."
  },
  {
    title: "13.3.",
    des: "Upon termination, you will be notified of it at your email address used to register with Payexchange."
  },
  {
    title: "13.4.",
    des: "Payexchange is not liable to you or any third party for termination of relationship with you irrespective of the termination reason."
  },
  {
    title: "13.5.",
    des: "You may terminate your relationship with us at any time by requesting to close your Account. Your request should be issued in writing by email used to register with Payexchange and shall only be processed if you have no pending obligation to us; otherwise, your Account will not be closed until you fulfil any and all your obligations towards us, unless Payexchange is in breach these Terms and such breach was not cured upon your request issued by email and therefore, you are not able to fulfil your obligations."
  },
  {
    title: "13.6.",
    des: "Upon the termination of these Terms: (i) all rights granted herein shall terminate immediately; (ii) you shall remit in full all fees and other payments due to Payexchange according to these Terms accruing prior to the date of termination; (iii) any provision of these Terms that by its very nature or context is intended to survive any termination, cancellation or expiration hereof, shall so survive; and (iv) all other performance obligations of both parties under these Terms shall cease."
  },
  {
    title: "13.7.",
    des: "Termination of the Terms shall not exempt you from the due discharge of all obligations to us arising before the date of termination."
  },
  {
    title: "13.8.",
    des: "Termination of these Terms shall also mean the termination of all Services Terms concluded between you and us."
  },
  {
    title: "13.9.",
    des: "Transactions initiated under the Terms before their termination shall be completed in accordance with the provisions of the Terms applicable before their termination, unless otherwise agreed by you and us."
  }
]
export const WARRANTY = [
  {
    title: "14.1.",
    des: "All information is provided “as is” without warranty of any kind, express or implied and your use of our Services is at your own risk."
  },
  {
    title: "14.2.",
    des: "To the extent permitted by law we do not warrant the reliability, availability, accuracy, completeness or timeliness of information on the Platform. Without any limitation to the former, Payexchange does not warrant that any Services including, but not limited to, the Platform shall run without errors or defects. Payexchange does not give any implied warranties of merchantability, fitness for a particular purpose, title or non-infringement."
  },
  {
    title: "14.3.",
    des: "Payexchange does not warrant that it will meet your requirements or will be available uninterruptedly or secure at any time or location. Payexchange does not warrant that its Services are free from viruses or other harmful content."
  },
  {
    title: "14.4.",
    des: "Payexchange does not warrant, endorse, guarantee or assume any responsibility and liability for any product or service offered or advertised by a third party through the Services or through the Platform, and Payexchange will not monitor or be held liable for any interactions between you and third-party providers of products and/or services through the use of or access to the Platform."
  }
]
export const CONFIDENTIALITYOBLIGATIONS = [
  {
    title: "15.1.",
    des: "The parties acknowledge that, from time to time, the party (the “Disclosing Party”) may disclose to the other party (the “Receiving Party”) either directly or indirectly by way of using/rendering the Services, electronically, in writing, orally or otherwise, information which is proprietary or confidential or which would, under the circumstances, be understood by a reasonable person to be proprietary and non-public, including without limitation, the information on the content of Transactions, security requirements related to Transactions, technical data, know-how, trade secrets related to activities of any of the parties, the non-public Payexchange information and all unpublished service manuals, information, data and other similar materials or records provided by the party to the other party pursuant to these Terms or otherwise (“Confidential Information”)."
  },
  {
    title: "15.2.",
    des: "The Receiving Party shall use such Confidential Information solely for fulfilling its responsibilities and obligations under these Terms and for no other purposes. The Receiving Party shall retain such Confidential Information in strict confidence and shall not disclose it to any third party without the Disclosing Party’s written consent, except to the third party(-ies) engaged/contacted by Payexchange in order to ensure provision of Services/compliance with applicable legislation as well as to law enforcement."
  },
  {
    title: "15.3.",
    des: "Each party shall use at least the same procedures and degree of care which it uses to protect its own Confidential Information of like importance, and in no event less than reasonable care, and shall be responsible and liable for any use or disclosure of the Confidential Information, including by its employees or other related persons, in violation of these Terms."
  },
  {
    title: "15.4.",
    des: "The party shall immediately notify the other party of any unauthorized use or disclosure, or suspected unauthorized use or disclosure of Confidential Information."
  },
  {
    title: "15.5.",
    des: "The obligations set forth in this Sections shall not apply to information that the Receiving Party is able to demonstrate, through clear and convincing evidence:"
  },
  {
    title: "a.",
    des: "was already known to the Receiving Party without an obligation of confidentiality at the time of disclosure hereunder;"
  },
  {
    title: "b.",
    des: "was generally available to the public at the time of its disclosure to the Receiving Party hereunder;"
  },
  {
    title: "c.",
    des: "became generally available to the public after its disclosure other than through an act or omission of the Receiving Party in breach of these Terms;"
  },
  {
    title: "d.",
    des: "was subsequently, lawfully and independently disclosed to the Receiving Party by a person other than the Disclosing Party, not in violation of the confidentiality agreement, arrangement or understanding with such person."
  },
  {
    title: "15.6.",
    des: "In the event that any disclosure of the Confidential Information is required by User pursuant to applicable law, User shall provide Payexchange a reasonable notice and opportunity to contest the need for such disclosure, or to seek a protective order therefor. If Payexchange fails to contest the need for such disclosure or to obtain a protective order, User may disclose only that portion of the Confidential Information that is legally so required to be disclosed, provided that any Confidential Information so disclosed shall maintain its confidentiality protection for all purposes other than such legally required disclosure."
  },
  {
    title: "15.7.",
    des: "User shall acknowledge and agree that the disclosure of information which may be considered as confidential to competent authorities and subcontractors of the Payexchange as well as other persons engaged/contacted by Payexchange for the provision of Services/compliance with applicable legislation, shall not be considered as a breach of the confidentiality obligations."
  }


]
export const COMPLAINTSANDDISPUTES = [
  {
    title: "16.1.",
    des: "Payexchange is committed to providing its Users with a very high level of customer service, and your satisfaction is very important to us. In case you would like to make a complaint, we encourage you to read the Complaint policy here and fill the provided form. We shall acknowledge your complaint within 5 (five) business days and make sure your complaint is investigated properly."
  }
]

export const AMENDMENTSTOTHESETERMS = [{
  title: "17.1.",
  des: "We shall have a right at any time to unilaterally amend these Terms including any part thereof by publishing the amended Terms on our website."
},
  {
    title: "17.2.",
    des: "The amended Terms shall come into force in 7 (seven) calendar days upon their publication on our website. Any subsequent access to or use by you of the Platform shall constitute an acceptance of the amended Terms."
  },
  {
    title: "17.3.",
    des: "If you do not want to accept amended Terms, please implement the procedure referred to in Article 13.5 for the termination of relationship with us."
  }]
export const COMMUNICATION = [{
  title: "18.1.",
  des: "We conduct any and all communication with you via email at the address you used to register with Payexchange. Our email address for communication is info@Payexchange.com. You are solely responsible to continuously check your email as we might send important information in relation to our Services or your Account. All emails shall be considered as received on the same business day such emails were sent, except they were sent on a non-business day – in such a case emails are considered to be received on the earliest following business day."
},
  {
    title: "18.2.",
    des: "User must immediately inform Payexchange about changes in his contact details. At the request of Payexchange, User must provide the respective documents supporting the change of any contact details. If User does not fulfill his duties referred to in this Article, the notifications communicated on the basis of the most recent contact details specified by User to Payexchange shall be deemed as duly sent and any obligation fulfilled on the basis of such details – as duly discharged by Payexchange."
  }]

export const MISCELLANEOUS = [
  {
    title: "19.1.",
    des: "Documents to be provided by User to Payexchange. Payexchange shall have the right to require User to provide original documents and/or copies certified by a notary or any other person authorized by the state. Payexchange shall also have a right to require that documents drawn up abroad be translated into English and/or legalized and/or attached with an Apostille, unless international treaties concluded between the Republic of Lithuania and the respective foreign country establish otherwise."
  },
  {
    title: "19.2.",
    des: "All costs of drafting, delivery, certification, notarization, apostillization and translation of documents to be provided to Payexchange shall be borne by the User."
  },
  {
    title: "19.3.",
    des: "If documents provided by the User to Payexchange are inconsistent with the requirements established by legal acts and/or by Payexchange, and/or if Payexchange has reasonable doubt as to the authenticity or accuracy of the submitted documents, Payexchange shall have the right to suspend User‘s access to the Platform and/or provision of Services to User and/or to demand from User the submission of additional documents."
  },
  {
    title: "19.4.",
    des: "Governing law and jurisdiction. These Terms, Privacy Policy and all other related documents referred to herein are governed by and interpreted in accordance with the laws of the Republic of Lithuania. All disputes and controversies arising out of or in connection with these Terms shall be submitted to the courts in Vilnius, the Republic of Lithuania."
  },
  {
    title: "19.5.",
    des: "Validity. These Terms shall be valid as long as you use the Platform and/or Services."
  },
  {
    title: "19.6.",
    des: "Enforceability. No provisions of these Terms shall be enforceable by any other person other than you and Payexchange."
  },
  {
    title: "19.7.",
    des: "Assignments. Your Account is personal and you may not assign or transfer in any way any rights and obligations under the Terms to any third party. Payexchange may transfer its rights and obligations arising out of these Terms or in relation to these Terms to any third party without your prior consent."
  },
  {
    title: "19.8.",
    des: "Sub-contraction. Payexchange shall be entitled to subcontract any third party for the purposes of provision of Services to you."
  },
  {
    title: "19.9.",
    des: "Improvement of the Platform. Payexchange shall have the right to at any time develop, improve, and otherwise modify the Platform, website and/or other IT matters related to the Services, including quantity of functions, their scope, procedure for use of the functions, scope of data required from you, etc."
  },
  {
    title: "19.10.",
    des: "Relationship of the parties. The parties are independent contractors and nothing in the Terms shall make the parties joint venturers, partners, employees, agents or other representatives of the other party. Neither party shall make any representation that suggests otherwise."
  },
  {
    title: "19.11.",
    des: "Ownership of intellectual property. User acknowledges and agrees that access to the Platform and usage of Services will include and provide him with access to various documents, processes, software and other technologies and materials, to which Payexchange and/or one or more third parties will hold all intellectual property rights."
  },
  {
    title: "19.12.",
    des: "All copyrights, trademarks, patents, trade secrets and other Intellectual Property Rights relating to the Platform and Services, including the systems, platforms, software and documentation provided by Payexchange to User are the property of Payexchange and/or the third party which granted Payexchange the right to provide/supply them."
  },
  {
    title: "19.13.",
    des: "Invalidity. In case any provision of these Terms is recognised as invalid or impossible to implement, it shall not have an impact on the validity of the remaining provisions of these Terms."
  },
  {
    title: "19.14.",
    des: "Waiver. Any failure or delay in exercising any right or remedy in one or many instances shall not prohibit Payexchange from exercising it at a later time or from exercising any other right or remedy."
  },
  {
    title: "19.15.",
    des: "Effect. All provisions of these Terms which by their nature shall be intended to continue shall survive termination of our relationship, including terms relating to exclusions and limitations of Payexchange liability, intellectual property restrictions and reimbursement of damages."
  },
  {
    title: "19.16.",
    des: "Language. User and Payexchange shall agree that the language of these Terms as well as communication between you and us is to be English."
  }
]